import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { CiCdConfigService } from 'src/cicd/ci-cd-config.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

export interface IUserIdentity {
  v_documento: string;
  v_apellido_2: string;
  v_apellido_1: string;
  acceso: string;
  v_nombre_1: string;
  v_usuario: string;
  v_nombre_2: string;
  v_pais: string;
  v_estado: string;
  v_ultima_contrasena: Date;
  v_contrasena: string;
  acciones: Accione[];
  v_tipo_usuario: string;
  v_tipo_documento: string;
  v_idrol: string;
  v_sucursal: string;
}

export interface Accione {
  descripcion: string;
  estado: boolean;
  idopcion: number;
}


@Component({
  selector: 'app-report-charts-page',
  templateUrl: './report-charts-page.component.html',
  styleUrls: ['./report-charts-page.component.scss']
})
export class ReportsChartsPageComponent implements OnInit {

  public link: string = "";
  public urlMicrofrontReportsCharts: string = "";
  public isProductionEnv: boolean = false;
  public url: SafeResourceUrl;
  public urlMicrofrontendProduction: "";
  public urlApiReports: string = "";
  public authReports: string = "";


  private confirmationSubject: Subject<boolean> = new Subject<boolean>();

  @ViewChild("iframe") iframe: ElementRef;

  constructor(
    private domSanitizer: DomSanitizer,
    public router: Router,
    public spinner: NgxSpinnerService,
    private readonly ciCd: CiCdConfigService
  ) {
    this.ciCdInit();
    this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.link);
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.confirmationSubject.next();
    this.confirmationSubject.complete();
  }

  ngAfterViewInit(): void {
    const { affiliateName, affiliateDocument } = this.handleGetUserData();
    this.handleRenderUsersFromAffiliate({
      affiliateName, affiliateDocument
    });
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApiReports, authReports, production } = apis;
      this.urlMicrofrontReportsCharts = this.handleGetDomainFromHost();
      this.urlApiReports = urlApiReports;
      this.authReports = authReports;
      this.isProductionEnv = production;
    });
  }

  handleRenderUsersFromAffiliate({ affiliateName, affiliateDocument }: any) {
    try {
      this.link = `${this.urlMicrofrontReportsCharts}assets/microfrontend/graficas/?affiliateDocument=${affiliateDocument}&service=${this.urlApiReports}&auth=${this.authReports}`;
      this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.link);
    } catch (error) {
      this.errorAlert("acceder a la página", error);
    }
  }

  errorAlert(message: string, error: any) {
    Swal.fire({
      type: "error",
      title: `No se pudo ${message}`,
      text: error ? error : "Por favor intente más tarde",
    });
  }

  closeUsersPage(value: boolean) {
    this.confirmationSubject.next(value);
  }

  handleGetUserData(): { affiliateName: string, affiliateDocument: string } {
    const identity: IUserIdentity = JSON.parse(localStorage.getItem("identityCVE")) || {};
    const { v_nombre_1, v_nombre_2, v_apellido_1, v_apellido_2, v_usuario } = identity;
    const affiliateName = `${v_nombre_1 || ""} ${v_nombre_2 || ""} ${v_apellido_1 || ""} ${v_apellido_2 || ""}`.trim();
    const affiliateDocument = identity.v_documento || "";
    const user = affiliateName || v_usuario || "--";
    console.log({ affiliateName, affiliateDocument });
    return { affiliateName: user, affiliateDocument };
  }

  handleGetDomainFromHost(): string {
    const { host, origin, pathname = '' } = window.location;
    return `${origin}${pathname ? pathname : ''}`;
  }

}
